<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <date-picker
          v-model="search.pay_off_at_S"
          :position="'left'"
          placeholder="繳滿日期開始"
        ></date-picker>

        <date-picker
          v-model="search.pay_off_at_E"
          :position="'left'"
          placeholder="繳滿日期結束"
        ></date-picker>
      </div>
    </div>

    <b-button
      variant="success"
      @click="contractNoticePdf('normal')"
    >
      正常版 - 繳滿通知函PDF
    </b-button>

    <b-button
      variant="primary"
      @click="contractNoticePdf('behalf_debt')"
    >
      墊繳到期未還款版 - 繳滿通知函PDF
    </b-button>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :enableDownload="print.enableDownload"
      :isIframePreviewPdf="print.isIframePreviewPdf"
      :filename="print.filename"
      :params="print.pdfParams"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
        <template v-if="print.type === 'normal'">
          <normal-payment-full-notice
            v-for="(item, index) in print.list"
            :key="index"
            :data="item"
          ></normal-payment-full-notice>
        </template>

        <template  v-else-if="print.type === 'behalf_debt'">
          <behalf-debt-payment-full-notice
            v-for="(item, index) in print.list"
            :key="index"
            :data="item"
          ></behalf-debt-payment-full-notice>
        </template>
      </template>
    </html-to-pdf>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import contractApi from "@/models/API/contractApi";
import datePicker from '@/components/common/DatePicker';
import HtmlToPdf from '@/components/common/HtmlToPdf';
import NormalPaymentFullNotice from '@/components/common/PrintTemplate/NormalPaymentFullNotice';
import BehalfDebtPaymentFullNotice from '@/components/common/PrintTemplate/BehalfDebtPaymentFullNotice';

export default {
  name: 'contractNotice',
  components: {
    BreadCrumb,
    datePicker,
    HtmlToPdf,
    NormalPaymentFullNotice,
    BehalfDebtPaymentFullNotice
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '契約管理', url: '', isActive: true },
          { name: '通知書', url: '', isActive: false }
        ]
      },
      search: {
        pay_off_at_S: '',
        pay_off_at_E: '',
        behalf_debt: 0
      },
      status: {
        resetDom: false
      },
      print: {
        list: [],
        type: null,
        filename: '',
        enableDownload: false,
        isIframePreviewPdf: true,
        pdfParams: {
          format: 'a4',
          orientation: 'p'
        }
      },
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
    // 產生PDF
    contractNoticePdf(type) {
      if (!this.search.pay_off_at_S || !this.search.pay_off_at_E) {
        const result = { message: '請選擇日期!!', title: '通知書' };
        this.contractApi.toast(() => {}, result, false);

        return;
      }

      if (type === 'normal') {
        this.search.behalf_debt = 0;

        this.print = {
          type: 'normal',
          filename: '正常版 - 繳滿通知函PDF',
          enableDownload: true,
          isIframePreviewPdf: false,
          pdfParams: {
            format: 'a5',
            orientation: 'l'
          }
        };
      } else if (type === 'behalf_debt') {
        this.search.behalf_debt = 1;

        this.print = {
          type: 'behalf_debt',
          filename: '墊繳到期未還款版 - 繳滿通知函PDF',
          enableDownload: true,
          isIframePreviewPdf: false,
          pdfParams: {
            format: 'a5',
            orientation: 'l'
          }
        };
      }

      this.contractApi.getMember(async(response) => {
        const res = response.data;

        this.status.resetDom = true;
        this.print.list = res.data;

        this.$forceUpdate();
        await this.$nextTick();

        this.$refs.htmlToPdf.generatePdf();
      }, this.search)

    },
    // 正常版格式處理
    async normalFormatHandler() {
      this.print = {
        type: 'normal',
        filename: '正常版 - 繳滿通知函PDF',
        enableDownload: true,
        isIframePreviewPdf: false,
        pdfParams: {
          format: 'a5',
          orientation: 'l'
        }
      };

      this.$forceUpdate();
      await this.$nextTick();

      this.$refs.htmlToPdf.generatePdf();
    },
    // 墊繳到期未還款版格式處理
    async behalfDebtFormatHandler() {
      this.print = {
        type: 'behalf_debt',
        filename: '墊繳到期未還款版 - 繳滿通知函PDF',
        enableDownload: true,
        isIframePreviewPdf: false,
        pdfParams: {
          format: 'a5',
          orientation: 'l'
        }
      };

      this.$forceUpdate();
      await this.$nextTick();

      this.$refs.htmlToPdf.generatePdf();
    },
     // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();
    },
  }
}
</script>

<style lang="scss" scoped>
.operate {
  margin-bottom: 20px;
  .search {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}
@media (max-width: 767px) {
  .operate {
    .search {
      div {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/contractNotice.vue